import * as styles from "./IntroHeroWithSubheading.module.scss";

import React from "react";
import CurvedBorderShallow from "../../../components/borders/CurvedBorderShallow";
import { Colours } from "../../../utils/colours";

interface IntroHeroWithSubheadingProps {
	title: string;
	subHeading?: string;
	htmlSubHeading?: string;
	borderBottomColor?: string;
}

export const IntroHeroWithSubheading: React.FC<IntroHeroWithSubheadingProps> =
	({
		title,
		subHeading,
		htmlSubHeading,
		borderBottomColor = Colours.SANDY_FUR,
	}) => {
		const getSubHeading = () => {
			if (subHeading?.length > 0)
				return (
					<div className={styles.subheading}>
						<p>{subHeading}</p>
					</div>
				);
			if (htmlSubHeading?.length > 0)
				return (
					<div
						className={styles.subheading}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{ __html: htmlSubHeading }}
					/>
				);
			return null;
		};
		return (
			<div className={styles.herowithimagecontainer}>
				<div className={styles.topsectionouter}>
					<div className={styles.textcontainer}>
						<div className={styles.title}>
							<h1>{title}</h1>
						</div>
						{getSubHeading()}
					</div>
				</div>
				<div className={styles.bordersection}>
					<CurvedBorderShallow
						className={styles.border}
						fill={borderBottomColor}
						rotation={0}
					/>
				</div>
			</div>
		);
	};

export default IntroHeroWithSubheading;
